import { registerNotification } from './registry'

registerNotification('challenge:published', {
  color: (_, theme) => theme.semantic.positive,
  icon:  () => 'challenge',
})